import React, { useState } from "react";
import { useContent } from "../lib/content";
import { useBuyerContent } from "../lib/buyerContent";
import { useAuth } from "../lib/auth";
import { Check } from "lucide-react";

export default function Closing() {
  const { content } = useContent();
  const { user } = useAuth();
  const { buyerClosing } = useBuyerContent();
  // Buyers get their per-buyer closing override (falling back to the agent's
  // global buyer closing); sellers keep the seller closing checklist.
  const items = user?.active_side === "buy" ? (buyerClosing || []) : (content.closing || []);
  const [checked, setChecked] = useState(new Set());
  const toggle = (id) => {
    const n = new Set(checked); n.has(id) ? n.delete(id) : n.add(id); setChecked(n);
  };

  return (
    <div className="container-x" style={{ padding: "48px 0 64px" }}>
      <span className="overline">Closing day</span>
      <h1 className="font-serif" style={{ fontSize: "clamp(2rem, 4vw, 3rem)", fontWeight: 500, margin: "8px 0 12px", letterSpacing: "-0.01em" }}>
        Almost there!
      </h1>
      <p style={{ color: "var(--text-muted)", maxWidth: 680, fontSize: "1.05rem" }}>A short list of last details so closing day goes smoothly.</p>

      <div className="card" style={{ padding: 32, marginTop: 32, maxWidth: 720 }} data-testid="closing-checklist">
        {items.map((item) => {
          const isChecked = checked.has(item.id);
          return (
            <div key={item.id} className={`check-item ${isChecked ? "checked" : ""}`} onClick={() => toggle(item.id)} data-testid={`closing-item-${item.id}`} role="button">
              <div className="check-box">{isChecked && <Check size={14} color="#fff" strokeWidth={3} />}</div>
              <div className="check-label">{item.label}</div>
            </div>
          );
        })}
      </div>

      <div className="card" style={{ padding: 28, marginTop: 24, maxWidth: 720, background: "var(--surface-alt)" }}>
        <div className="overline">Home condition</div>
        <p style={{ marginTop: 8, color: "var(--text)" }}>
          Your home should be left in <b>broom-clean</b> condition. Remove all personal items, sweep floors, wipe counters, and leave appliance manuals plus remotes / spare keys on the kitchen counter.
        </p>
      </div>
    </div>
  );
}
